import React from "react";
import loaderVideo from "../Assets/videoes/loaderVideo.webm";
import "../Assets/styles/Loader.css";

const Loader = () => {
  return (
    <div className="spinner-loader">
      <video
        className="loader-video"
        src={loaderVideo}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
};

export default Loader;
